import { useState } from "react";
import { Helmet } from "react-helmet";
import { VideoBackground } from "@/components/VideoBackground";
import { MinimalisticPlayer } from "@/components/MinimalisticPlayer";
import { FooterLinks } from "@/components/FooterLinks";
import { SEOFooter } from "@/components/SEOFooter";
import { SEOHead } from "@/components/SEOHead";
import { StructuredData } from "@/components/StructuredData";
import { Snowfall } from "@/components/Snowfall";
import { FestiveLights } from "@/components/FestiveLights";

const Index = () => {
  const [selectedAirport, setSelectedAirport] = useState<string>("");
  const [snowfallIntensity, setSnowfallIntensity] = useState<number>(50);

  const handleAirportSelect = (airportCode: string) => {
    setSelectedAirport(airportCode);
  };

  return (
    <>
      <SEOHead />
      <StructuredData />
      <Snowfall intensity={snowfallIntensity} />
      <FestiveLights />
      <VideoBackground
        storageKey="background-video.mp4"
        title="Ambient airplane flying above clouds - Sky Lofi ATC background video"
      />
      
      <header className="sr-only">
        <h1>Sky Lofi ATC - Free Lofi Hip Hop Beats with Live Air Traffic Control Radio for Studying and Focus</h1>
        <p>Stream free ambient lofi music mixed with real-time ATC radio communications from major international airports worldwide. Perfect 24/7 background music for studying, coding, working, and deep concentration.</p>
      </header>

      <main role="main">
        <MinimalisticPlayer 
          selectedAirport={selectedAirport}
          onAirportSelect={handleAirportSelect}
          snowfallIntensity={snowfallIntensity}
          onSnowfallIntensityChange={setSnowfallIntensity}
        />
      </main>

      <FooterLinks />
      
      <footer role="contentinfo">
        <SEOFooter />
      </footer>
    </>
  );
};

export default Index;
